<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button type="primary" size="small" @click="openAdd('add')" icon="el-icon-edit">新建</el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.cat_cname">
                        <span slot="prepend">{{$t('cname')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list(false)">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table class="el-table--border" :data="listData" style="width: 100%" height="100%">
                    <el-table-column prop="cat_cname" :label="listHeader.cat_cname" width="150px"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" width="150px"></el-table-column>
                    <el-table-column :label="$t('op')" width="60px">
                        <template slot-scope="scope">
                            <a class="link" @click="openSave('upd', scope.row.cat_id)">{{$t('info')}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="300px">
                        <template slot-scope="scope" slot="header">
                            <div class="flex-box nopadding">
                                <div class="tleft" style="width: 160px">{{listHeader2.cat_cname}}</div>
                                <div class="tleft" style="width: 60px">{{listHeader2.cat_status_cdesc}}</div>
                                <div class="tleft" style="width: 80px"></div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <div class="flex-box nopadding border-bottom-line" v-for="(item2, index2) in scope.row.children" :key="index2">
                                <div class="tleft" style="width: 160px">{{item2.cat_cname}}</div>
                                <div class="tleft" style="width: 60px">{{item2.cat_status_cdesc}}</div>
                                <div class="tleft" style="width: 80px">
                                    <a class="link" @click="openSave2('upd', scope.row, item2)">{{$t('info')}}</a>
                                </div>
                            </div>
                            <div class="f-blue hand mg-top10" @click="openAdd2('add', scope.row)">新增二级分类</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDropdown from '../../../components/myDropdown'
    import myDatePicker from '../../../components/myDatePicker'
    export default {
        name:'base-goodscat',
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker
        },
        data:function(){
            const listHeader = {
                cat_cname: this.$t('cname'),
                add_time: this.$t('add_time'),
            };
            const listHeader2 = {
                cat_cname: '二级分类',
                cat_status_cdesc: this.$t('status')
            };
            return{
                self:this,
                show_subview:false,
                relist:false,
                search:{
                    search_url: "base-goodscat/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    cat_cname: ""
                },
                listHeader,//表结构
                listHeader2,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.list();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function() {
                this.$base.exportExcel(this);
            },
            openAdd:function (op) {
                this.$base.linkTo("/base/goodscat/save",{op: op});
            },
            openSave:function (op, id) {
                this.$base.linkTo("/base/goodscat/save",{op, id});
            },
            openAdd2:function (op, item) {
                this.$base.linkTo("/base/goodscat/save2",{op:op,
                    cat_id:item.cat_id,
                    cat_cname:item.cat_cname,
                    cat_id2:'',
                });
            },
            openSave2:function (op, item, item2) {
                this.$base.linkTo("/base/goodscat/save2",{op:op,
                    cat_id:item.cat_id,
                    cat_cname:item.cat_cname,
                    cat_id2:item2.cat_id2,
                });
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base/goodscat/list.vue